module.exports = __webpack_public_path__ + "media/images/app/right-arrow-564ad84ce4276067c315879d9a3499bb.webp";